const __WEBPACK_NAMESPACE_OBJECT__ = require("json-rpc-random-id");